// extracted by mini-css-extract-plugin
module.exports = {"fieldWidth":"DeliveryPointCargoApproveForm_fieldWidth__3qFYo"};